import { alertRequest, body, request } from "services/request";

const resource = "api/refueling";

const getPlannedRefuelings = (bidId: number) => request(`${resource}/getPlannedRefuelings/${bidId}`, { method: "GET" });

const getSkippedRefuelings = (bidId: number) => request(`${resource}/getSkippedRefuelings/${bidId}`, { method: "GET" });

const editRefueling = (params: {}) => alertRequest(`${resource}/edit`, body(params));

const deleteRefueling = (params: {}) => alertRequest(`${resource}/delete`, body(params));

const addToPlanQueue = (params: {}) => request(`${resource}/addToPlanQueue`, body(params));

const deleteRefuelings = (params: {}) => alertRequest(`${resource}/deleteRefuelings`, body(params));

export { getPlannedRefuelings, addToPlanQueue, deleteRefuelings, editRefueling, deleteRefueling, getSkippedRefuelings };
